import { motion } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Cards.css";

const containerCard = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition: {
      type: "spring",
      stiffness: 120,
    },
  },
  hov: {
    scale: 1.05,
  },
};

const Card = ({ course }) => {
  return (
    <div className="m-2 link-custom">
      <Link to={`/course-inside/${course._id}`} className="link-custom">
        <motion.div
          className="card card-custom"
          variants={containerCard}
          whileHover="hov"
        >
          <img
            src={course.photo}
            className="card-img-top card-img-top-custom"
            alt="courseImage"
            style={{ width: "100%", height: "200px" }}
          />
          <div className="card-body">
            <div className="card-payment-custom">
              <h5 className="card-title card-title-custom">
                {course.name?.substring(0, 20)}...
              </h5>
              <span>
                <h6>{course.price}</h6>
              </span>
            </div>
            <p className="card-text card-text-custom">
              {course.description?.text?.substring(0, 30)}...
            </p>
          </div>
        </motion.div>
      </Link>
    </div>
  );
};

export default Card;
